import actions from './actions';
import mutations from './mutations';
import state from './state';
import getters from './getters';

export default {
  namespaced: true,

  actions,
  getters,
  mutations,
  state,
};



// WEBPACK FOOTER //
// ./src/store/modules/alerts/index.js